export const Datepickers = {
	INPUT: 'input',
	INLINE: 'inline',
} as const;
